<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="节点名称" prop="flname">
                <el-input placeholder="请输入节点名称" v-model="ruleForm.flname"></el-input>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">修改</el-button>
                <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { updateGzwz } from "@/api/equipmentDic/index.js"
export default {
    props: ["subData"],
    data() {
        return {
            typeOptions: [{
                key: '1412261015343639',
                label: '052C'
            }, {
                key: '504012158172549',
                label: '054A'
            }],
            pidname:"",
            ruleForm: {
                flid:"",
                flname: ""
            },
            rules: {
                flname: [
                    { required: true, message: "请输入节点名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 50,
                        message: "长度在 2 到 50 个字符",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    updateGzwz(this.ruleForm).then(() => {
                        this.$message({
                            message: "修改成功",
                            type: "success",
                        });
                        this.$bus.$emit("faultLocation-list");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
    created() {
        this.ruleForm = this.subData.obj;
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>